// extracted by mini-css-extract-plugin
export default {"button":"simpleDateButton_button__tCAp2","label":"simpleDateButton_label__DQN81"};